import { type IReactionDisposer, makeAutoObservable, runInAction } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import type { IResponseIncomingTwilioNumbers } from 'entities/Phone/api/types'
import { StepsStore } from 'pages/settings/store/stepsStore'
import { NumbersPath } from 'pages/settings/pages/numbers/route/numbersPath'
import { type SettingsStore } from 'pages/settings/store/settingsStore'
import { ImportTwilioNumbersStore } from 'pages/settings/pages/numbers/ui/ImportTwilioNumbers/store/ImportTwilioNumbersStore'

export class NumbersLayerStore {
  private readonly _stepsStore: StepsStore
  private _importTwilioNumbersStore: ImportTwilioNumbersStore | null = null
  private _disposePageReaction: IReactionDisposer | null = null

  private _loading = false

  constructor(private _settingsContext: SettingsStore, private _entities: IEntitiesStore) {
    this._stepsStore = new StepsStore()

    makeAutoObservable(this)
  }

  redirectToRoot = () => {
    this.resetImportTwilioNumbersStore()

    uiStore.changeRouteViaVue({
      path: `/${NumbersPath.root}`,
    })
  }

  get loading() {
    return this._loading
  }

  get stepsStore() {
    return this._stepsStore
  }

  get settingsStore() {
    return this._settingsContext
  }

  get importTwilioNumbersStore() {
    return this._importTwilioNumbersStore
  }

  initImportTwilioNumbersStore = (numbers: IResponseIncomingTwilioNumbers['data']) => {
    this._importTwilioNumbersStore?.dispose()
    this._importTwilioNumbersStore = new ImportTwilioNumbersStore(numbers, this._entities)
  }

  resetImportTwilioNumbersStore = () => {
    this._importTwilioNumbersStore?.dispose()
    this._importTwilioNumbersStore = null
  }

  init = async () => {
    runInAction(() => {
      this._loading = true
    })

    // All common requests go here
    // await Promise.all([])

    runInAction(() => {
      this._loading = false
    })
  }

  dispose = () => {
    this._disposePageReaction?.()
    this.resetImportTwilioNumbersStore()
  }
}
